import Box from '../../../Common/Box';
import {Pagination, SxProps, Typography} from '@mui/material';
// import ControlButton from '../../../Common/ControlButton';
import ControlButton from '../../../Common/ControlButton_BU';
import Download from '@mui/icons-material/Download';
import {createThemeOptions} from '../getShadowTheme';
import React, {useContext, useState} from 'react';
import {ThemeContext} from "../../../Common/Contexts";
import {Theme, useTheme} from "@mui/material/styles";
import uiStore from "../../stores/uiStore";
import Paper from "@mui/material/Paper";
import {downloadStringAsFile} from "../../utils";


export function CloudView() {

    const theme: Theme & { name: string } = useTheme();

    const {
        name,
        palette: {
            mode,
            primary: {
                main
            },
            background: {
                default: backgroundDefault,
                paper,
            }
        }
    } = theme;

    const {themes, setTheme} = useContext(ThemeContext);


    const [pageIndex, setPageIndex] = useState(1);
    const pageSize = 20;
    const count = Math.ceil(themes.length / pageSize);
    const startIndex = (pageIndex - 1) * pageSize;
    const pageResults = themes.slice(startIndex, startIndex + pageSize);
    let sx: SxProps;

    if (uiStore.isMobile) {
        sx = {
            height: "200px"
        }
    }

    return <Box column expand
                sx={sx}
    ><Box row padding={"15px"}>
        {!uiStore.isMobile && <Typography
                fontSize={"16px"}
                variant={"overline"}
                sx={{marginRight: "auto"}}
        >
            User themes
        </Typography>}

    </Box>
        <Box width={"100%"} column overflow={"auto"} flex={1}>
            {
                pageResults.map((theme, i) => {
                    return <Box padding={"20px"} row key={i}>
                        <Paper elevation={4} sx={{
                            padding: "10px",
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            cursor: "pointer",
                        }}
                               onClick={() => {
                                   setTheme(
                                           //@todo On autofill we get a stringified value.
                                           theme
                                   );
                               }}
                        >
                            <Box row>
                                {theme.name}
                                <Box marginLeft={"auto"}>
                                    <ControlButton
                                            label={"Download theme"}
                                            icon={Download}
                                            onClick={(e: React.MouseEvent) => {
                                                const theme = createThemeOptions(name, mode, main, backgroundDefault, paper);
                                                downloadStringAsFile(JSON.stringify(theme, null, 2), theme.name + ".json");
                                                e.stopPropagation();
                                            }}
                                    />
                                </Box>
                            </Box>
                        </Paper>
                    </Box>
                })
            }
        </Box>

        <Pagination
                size={uiStore.isMobile ? "medium" : "medium"}
                page={pageIndex}
                sx={{
                    padding: "4px",
                    bgcolor: "background.paper",
                }}
                count={count}
                onChange={(e, pageIndex) => setPageIndex(pageIndex)}
        />
        {/* <Box flex={1} */}
        {/*      padding={"20px"} */}
        {/*      column */}
        {/*      alignItems={"center"} */}
        {/*      justifyContent={"flex-end"} */}
        {/* > */}
        {/*   <ColorButton */}
        {/*     onClick={() => { */}
        {/*         setSaveDialogOpen(true); */}
        {/*     }} */}
        {/*     endIcon={<Save/>} */}
        {/*     variant="contained" */}
        {/*   > */}
        {/*     Save theme */}
        {/*   </ColorButton> */}
        {/*   */}
        {/* </Box> */}
    </Box>
}
